// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field } from 'redux-form';
import AddressSection from './AddressSection';
import EntityTypeField from './EntityTypeField';

const EntitySection = () => (
    <>
        <div className="section_title">Entity Type*</div>
        <div className="radio_block">
            <Field
                name="entityType"
                component={EntityTypeField}
                placeholder=""
                required
            />
        </div>
        <AddressSection />
    </>
);

export default EntitySection;
